/**
 * Compile-time exhaustiveness check that still renders something at runtime.
 * Passing a value TypeScript cannot narrow to `never` is an error, so adding a
 * union member without handling it fails the build; the fallback keeps the
 * runtime behaviour intact rather than throwing mid-flow.
 */
export const assertNever = <T>(_unhandled: never, fallback: T): T => fallback
